import { withHandlers } from 'recompose'
import { setMapBounds } from 'map/actions'
import { zoomSelector, clustersSelector } from 'map/selectors'
import ClusterBaseMarker from 'map/components/cluster/Cluster'

export default compose(
    connect(
        createStructuredSelector({
            zoom: zoomSelector,
            clusters: clustersSelector,
        }),
        {
            setMapBounds,
        }
    ),
    withHandlers({
        onClick:
            ({ cluster_id, clusters, lat, lng, zoom, setMapBounds }) =>
            () =>
                setMapBounds({ lat, lng }, clusters.getClusterExpansionZoom(cluster_id, zoom) + 1),
    })
)(ClusterBaseMarker)
